import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

/**
 * Muestra una notificación de carga que puede permanecer abierta indefinidamente.
 * Si no se proporciona una 'key', se genera una automáticamente.
 *
 * Nota: La 'key' generada o proporcionada permite actualizar la notificación de carga al asignarla como valor de la propiedad 'key' en
 * el objeto de configuración de otra notificación, o destruirla usando notification.destroy(key).
 *
 * @param {object} config
 * @param {import('antd/es/notification/interface').NotificationInstance} config.notification Instancia de notificación de Ant Design.
 * @param {string} [config.key] Clave única para identificar la notificación.
 * @param {React.ReactNode} [config.description='Cargando...'] Descripción de la notificación.
 * @returns {string} La clave única de la notificación generada o proporcionada.
 */
export const showLoadingNotification = ({ notification, key, description = 'Cargando...' }) => {
  let notificationKey = key;

  if (!notificationKey) {
    const timestamp = Date.now();
    notificationKey = `loadingNotification${timestamp}`;
  }

  notification.open({
    key: notificationKey,
    message: (
      <Flex justify='center'>
        <Spin indicator={<LoadingOutlined />} />
      </Flex>
    ),
    description: <Flex justify='center'>{description}</Flex>,
    duration: 0, // Mantiene la notificación abierta indefinidamente
  });

  return notificationKey;
};
